
import { Component, namespace, Prop, Vue } from "nuxt-property-decorator";
import PeilstabPlus from "~/components/molecules/banner/PeilstabPlus.vue";
import NewsletterSignup from "~/components/organisms/form/NewsletterSignup.vue";
import PriceNotification from "~/components/organisms/form/PriceNotification.vue";

const FederalStatesModule = namespace("federalstates");

@Component({
  components: {
    NewsletterSignup,
    PriceNotification,
    PeilstabPlus,
  },
})
export default class DistrictFormSection extends Vue {
  @Prop({ required: true }) areaTypeLabel!: string;
  @Prop({ required: true }) products!: any;

  @FederalStatesModule.State("countyName")
  countyName;
}
